export const URLS = {
  NOT_FOUND: "/404",

  HOME: "/",

  PIZZA_SLICE: "/pizza-slice",

  // Search
  SEARCH: "/search",

  // Collections
  COLLECTIONS: "/collections/:handle",
  COLLECTIONS_ALL: "/collections/all",
  COLLECTIONS_DETAIL: "/collections",

  // Products
  PRODUCTS: "/products",
  PRODUCTS_DETAIL: "/products/:handle",

  // Checkout
  CHECKOUT: "/checkout",
  ORDER_COMPLETED: "/order-completed/:orderId",
  CHECKOUT_PAYMENT: "/checkout/payment/:handle",

  // Features
  FEATURES: "/features",

  // News
  NEWS: "/features/news",
  NEWS_DETAIL: "/features/news/:handle",

  // LookBook
  LOOKBOOK: "/features/lookbook",
  LOOKBOOK_DETAIL: "/features/lookbook/:handle",

  // Video
  VIDEO: "/features/videos",
  VIDEO_DETAIL: "/features/videos/:handle",

  // Account
  ACCOUNT: "/account",
  ORDER_HISTORY: "/account/order-history",
  ORDER_DETAIL: "/account/order/:handle",
  ORDER: "/account/order/",
  WISHLIST: "/account/wishlist",
  ADDRESSES: "/account/addresses",
  RETURN: "/account/return/:orderId",
  RETURN_REQUESTED: "/account/return",
  RETURN_REQUEST: "/account/return-request/:orderId",
  RETURN_REQUEST_DETAIL: "/account/return-request",
  MEMBERSHIP: "/account/membership",

  // Information
  INFORMATION: "/information",
  SHIPPING_AND_RETURNS: "/information#shipping-and-returns",

  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  PRIVACY_POLICY: "/privacy-policy",

  LEGAL: "/legal",
  RECRUIT: "/recruit",
  RECRUIT_DETAIL: "/recruit/:handle",

  // Customer Service
  MEMBERSHIP_PROGRAM: "/membership",

  // Connect
  STORES: "/stores",
  STORES_DETAIL: "/stores/:handle",
  STOCKISTS: "/stockists",

  // WeChat
  WECHAT: "/wechat",

  REFRESH: "/refresh",
};

export const DOMAIN = {
  ko: "https://thisisneverthat.com/",
  en: "https://intl.thisisneverthat.com/",
  jp: "https://thisisneverthat.jp/",
};

export const PREVIEW_DOMAIN = {
  ko: "https://d257kvs4acsh7t.cloudfront.net/",
  en: "https://dgklsgs33ap3q.cloudfront.net/",
  jp: "https://d1c8idxzjd63t3.cloudfront.net/",
};

export const SHOPIFY_DOMAIN = {
  ko: "https://thisisneverthatstore.myshopify.com/",
  en: "https://thisisneverthat-intl.myshopify.com/",
  jp: "https://thisisneverthat-jp.myshopify.com/",
};
